import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  label: {
    paddingBottom: 6,
  },

  switchContainer: {
    height: 32,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    borderBottom: `1px solid transparent`,

    width: "100%",
    alignItems: "center",

    "& > *": {
      marginLeft: theme.hv.spacing.xs,
    },
    "& > *:first-child": {
      marginLeft: 0,
    },
  },

  invalidSwitch: {
    borderBottom: `1px solid ${theme.hv.palette.semantic.sema4}`,
  },

  error: {},

  controlContainer: {
    width: "100%",
    maxWidth: 400,
  },

  labelContainer: {
    display: "flex",
    alignItems: "flex-start",
  },
}));

export default useStyles;
